<template>
    <div v-show="visible">
        <el-dialog title="查看评论" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="600px">
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="260"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border fit highlight-current-row>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="content" label="留言内容"></el-table-column>
                <el-table-column prop="gmtCreate" label="提交时间"></el-table-column>
                <el-table-column prop="createName" label="提交人"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>

<script>
    import http from '@/common/http';

    export default {
        name:"",
        data(){
            return{
                visible:false,
                loading:false,
                form:{
                    patrolId:""
                },
                data:[]
            }
        },
        components: {
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(id){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.patrolId=id

                this.getData();
            },
            indexMethod(index) {
                return index+1;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.getCommentLogsUrl;
                let data = {
                    patrolId:this.form.patrolId
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    console.log(res.data);
                    if(res.status==200){
                       this.data = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/patrol/commentInfo.vue